import { Theme } from 'helpers/theme';
import moment from 'moment';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {},
  buttons: {
    padding: '24px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '20px'
  },
  signatureBoxContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  signatureBox: {
    border: '1px dashed #d7d77a',
    padding: '11px 16px',
    minWidth: 229,
    background: '#ffffec',
    fontFamily: ['Caveat', 'cursive'],
    borderRadius: 5,
    fontSize: 22,
    position: 'relative'
  },
  signatureDate: {
    fontSize: 10,
    position: 'absolute',
    top: '-9px',
    right: 12,
    background: 'white',
    borderRadius: 5,
    padding: '4px 10px',
    border: '1px solid #e0e3e7'
  },
  signatureLabel: {
    fontSize: 14,
    marginRight: 26,
    color: '#000000'
  }
}));

type Props = {
  name: string;
  date?: string | null;
};

export default function Signature({ name, date }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.signatureBoxContainer}>
      <div className={classes.signatureLabel}>Signed:</div>
      <div className={classes.signatureBox}>
        {name}
        <div className={classes.signatureDate}>
          Date: {date || moment().format('DD/MM/YYYY')}
        </div>
      </div>
    </div>
  );
}
